@if (templateLoaded()) {
  <form [formGroup]="templateFormGroup" fxLayout="column" fxFlexFill style="height: 100%">
    <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
      <div fxFlex>{{ isTemplateNew ? 'Add' : 'Edit' }} Template</div>
      <button mat-icon-button [mat-dialog-close]="false" class="button-40">
        <mat-icon>close</mat-icon>
      </button>
    </h1>

    <mat-dialog-content fxLayout="column" fxFlex class="mat-typography" style="overflow: hidden">
      @if (serverError) {
        <div class="alert alert-danger alert-dismissible" role="alert">{{ serverError }}</div>
      }

      <app-mat-text-input
        formControlName="name"
        label="Template Name"
        name="name"
        [submitted]="formSubmitted()"
      ></app-mat-text-input>

      <app-mat-simple-select
        formControlName="type"
        label="Template Type"
        name="type"
        [selectItems]="templateTypes"
        [submitted]="formSubmitted()"
      ></app-mat-simple-select>

      <div fxLayout="row" style="margin-top: 10px">
        <button mat-flat-button color="primary" [disabled]="formSubmitted()" (click)="onAddButtonTemplate()">
          + Add Template Button
        </button>
      </div>

      <div fxFlex style="overflow: auto; padding-top: 20px; padding-bottom: 10px; padding-left: 1px">
        @for (buttonForm of formButtonsArray; track buttonForm) {
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <app-device-button
              fxFlex="90"
              [buttonForm]="buttonForm"
              [lookupButtonTypes]="lookupButtonTypes"
              [formSubmitted]="formSubmitted()"
              [btnIndex]="$index"
            ></app-device-button>

            <div fxFlex="10" fxLayoutAlign="center center">
              <button
                mat-icon-button
                type="button"
                color="warn"
                class="only-icon"
                [disabled]="formSubmitted()"
                (click)="onRemoveButton($index)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <div fxLayout="row" fxLayoutGap="10px">
        <button
          mat-flat-button
          type="submit"
          color="primary"
          [disabled]="!isFormValid"
          [promiseBtn]="formSubmitted()"
          (click)="onTemplateSave()"
        >
          Save
        </button>

        @if (!isTemplateNew) {
          <button
            mat-flat-button
            type="button"
            color="warn"
            class="only-icon"
            [disabled]="formSubmitted()"
            (click)="onTemplateDelete()"
          >
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    </mat-dialog-actions>
  </form>
} @else {
  <div fxLayout="column" fxFlexFill class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
